import request from '../../axios';

const getStoreTypeList = async () => {
  const {data}: {data: IStoreTypeList[]} = await request.get(
    `api/v2/store/store-type-list`,
  );
  return data;
};

export default getStoreTypeList;
